<template>
  <div>
    <i class="iconfont shangchuanfujian1"></i>
    <div>
      <div>
        <div v-if="showFileList.length">
          <div v-if="uploaadLoding" style="display: flex; margin-left: 20px">
            <Spin size="large" />
            <Spin size="large" />
            <Spin size="large" />
          </div>
          <div
            class="file-box"
            v-for="(item, index) in filesToDisplay"
            :key="index"
          >
            <Row>
              <Col>
                <i class="iconfont icon-shangchuanfujian-copy"></i>
                <!-- 使用图标 -->
              </Col>
              <Col>
                <div class="file-text" @click="openFile(item)">
                  <span
                    style="
                      max-width: 600px;
                      display: block;
                      line-height: normal;
                      white-space: break-spaces;
                    "
                  >
                    {{ item.file_name }}
                  </span>
                  <span v-if="selectedFile !== '全部' && isShowVersion">
                    (版本{{ selectedFile + 1 }})
                  </span>
                  <span v-if="selectedFile === '全部' && isShowVersion">
                    (版本{{ index + 1 }})
                  </span>
                </div>
              </Col>
              <Col>
                <!-- <span @click="(item)" class="action-btn">编辑</span> -->
                <Button
                  type="primary"
                  size="small"
                  style="margin-left: 10px"
                  @click="edit(item)"
                >
                  编辑
                </Button>
              </Col>
              <!-- <Col>
                <Upload
                  ref="upload"
                  action="/"
                  show-upload-list
                  style="display: inline-block"
                  :before-upload="(file) => resetUpload(file, item)"
                  v-if="isShowResetBtn"
                >
                  <Button
                    size="small"
                    type="primary"
                    v-if="isapprovalMeb && isShowPackage"
                  >
                    重新上传
                  </Button>
                </Upload>
              </Col> -->
              <Col>
                <span
                  v-if="isShowDelBtn(item)"
                  @click="deleteFile(item)"
                  class="action-btn"
                  style="color: #871f27"
                >
                  删除
                </span>
                <!-- <Button
                  v-if="isShowDelBtn(item)"
                  type="error"
                  size="small"
                  @click="deleteFile(item)"
                >
                  删除
                </Button> -->
              </Col>
            </Row>
            <Progress
              v-if="item.showProgress"
              :percent="item.percentage"
              hide-info
            ></Progress>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <!-- <div
          v-if="
            (isapprovalMeb && isShowPackage) ||
            (isapprovalMeb && buttonText === '上传发文内容') ||
            (isShowPackage === false &&
              buttonText !== '上传发文内容' &&
              isEditStatus === '新增') ||
            isEditStatus === '修改'
          "
        >
          <Upload
            ref="upload"
            action="/"
            show-upload-list
            style="display: inline-block"
            :before-upload="beforeUpload"
          >
            <Button size="small" type="primary">{{ buttonText }}</Button>
          </Upload>
        </div> -->
        <div v-if="!isShowPackage">
          <Upload
            ref="upload"
            action="/"
            show-upload-list
            style="display: inline-block"
            :before-upload="beforeUpload"
            accept=".doc,.docx"
            :disabled="disabledUpload"
          >
            <Button size="small" type="primary" v-show="!showFileList.length">
              {{ buttonText }}
            </Button>
            <a href="https://jk.lockhea.com/posetup_6.3.1.2.exe">
              在线编辑插件下载
            </a>
          </Upload>
          <!-- <Button size="small" type="warming" v-show="showFileList.length">在线编辑</Button> -->
        </div>
        <div v-if="isShowPackage && filesToDisplay.length !== 0">
          <Button
            size="small"
            type="primary"
            @click="downloadZip(showFileList)"
          >
            打包下载
          </Button>
        </div>
      </div>
      <!-- 预览弹窗 -->
      <Modal title="预览" v-model.trim="modalShow" draggable :fullscreen="true">
        <div class="modal-content">
          <lookOverFile :filepath="filepath" :filetype="filetype" />
        </div>
        <div slot="footer"></div>
      </Modal>
    </div>
    <div
      v-if="
        (isapprovalMeb && isShowPackage) ||
        (isapprovalMeb && buttonText === '上传发文内容') ||
        (isShowPackage === false &&
          buttonText !== '上传发文内容' &&
          isEditStatus === '新增') ||
        isEditStatus === '修改'
      "
      style="
        margin-top: 3px;
        margin-bottom: 10px;
        color: #6ea0ff;
        line-height: normal;
      "
    >
      <span v-show="!disabledUpload">
        单次可上传附件大小不超过100M
        <span style="color: red">*修改附件要点提交才生效!</span>
      </span>

      <span v-show="disabledUpload" style="color: #871f27">
        请先选择公文模板
      </span>
    </div>
    <Modal v-model="iframeVisible" width="800">
      <iframe
        :src="iframeSrc"
        v-if="iframeVisible"
        style="width: 750px; height: 200px; border: none; margin-top: 100px"
      ></iframe>
    </Modal>
    <Drawer v-model="luckysheelShow" width="100">
      <div
        id="luckysheet"
        v-show="luckysheelShow"
        style="width: 100%; height: 100%"
      ></div>
    </Drawer>
  </div>
</template>

<script>
import lookOverFile from '../look-over-file/index.vue';
import { mapGetters } from 'vuex';
import { postData } from './api';
import LuckyExcel from 'luckyexcel';
// 创建一个新的Vue实例作为事件总线
export default {
  props: {
    buttonText: {
      type: null,
      default: '上传',
    },
    id: {
      type: null,
      default: null,
    },
    showFileList: {
      type: null,
      default: () => [],
    },
    fileIdList: {
      type: null,
      default: () => [],
    },
    uploaadLoding: {
      type: null,
      default: false,
    },
    isEditStatus: {
      type: null,
      default: '新增',
    },
    selectedFile: {
      type: null,
      default: '全部',
    },
    isShowVersion: {
      type: Boolean,
      default: false,
    },
    isShowPackage: {
      type: null,
      default: false,
    },
    isShowResetBtn: {
      type: null,
      default: true,
    },
    disabledUpload: {
      type: Boolean,
      default: false,
    },
    isShowEditDocBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    lookOverFile,
  },
  data() {
    return {
      modalShow: false,
      filetype: '',
      filepath: '',
      approval: '',
      isapprovalMeb: false, //是否是审批人
      isApplication_user: false,
      iframeSrc: '',
      iframeVisible: false,
      luckysheelShow: false,
    };
  },
  computed: {
    ...mapGetters(['approvalFromStore']),
  },
  created() {
    if (
      this.approvalFromStore.currentapprovals &&
      this.approvalFromStore.currentapprovals.some
    ) {
      this.isapprovalMeb = this.approvalFromStore.currentapprovals.some(
        (element) => element.approvalid === this.$store.state.user.userId,
      );
    }
  },
  mounted() {
    console.log(this.id, '主表id');
    console.log(isShowEditDocBtn, '是否显示编辑按钮');
    //this.getApprovalRecordInfo();
    //console.log(this.approvalFromStore,'333333333333')
  },
  watch: {
    approvalFromStore(newVal) {
      this.approval = newVal.currentapprovals;
      this.isapprovalMeb = newVal.currentapprovals.some(
        (element) => element.approvalid === this.$store.state.user.userId,
      );
      this.approvalStatus = newVal.audit_status;
      console.log(this.approvalStatus);
    },
    id(newVal) {
      this.getApprovalRecordInfo(newVal);
    },
  },
  computed: {
    filesToDisplay() {
      if (this.selectedFile === '全部') {
        return this.showFileList;
      } else {
        return this.showFileList.filter(
          (file, index) => index === this.selectedFile,
        );
      }
    },
    approvalFromStore() {
      return this.$store.getters.approval;
    },
  },
  methods: {
    async edit(item) {
      if (item.file_name.includes('.docx') || item.file_name.includes('.doc')) {
        let param = {
          type: 'postingeditor',
          fileid: item.file_id,
          // templateid: "",
          // username: this.$store.state.user.userId,
          // formid: this.formValidate.posting_id,
          //formdata:Base64.encode(JSON.stringify(this.formValidate)),
        };
        this.iframeVisible = true;
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.iframeSrc = `onlineEditor/?type=${param.type}&fileid=${param.fileid}&templateid=${param.templateid}`;
          });
        });
        setTimeout(() => {
          this.$Modal.remove();
          this.iframeVisible = false;
          this.$forceUpdate();
        }, 5000);
      }
    },
    // 查询审批记录
    async getApprovalRecordInfo(id) {
      let res = await postData(
        '/admin/Approval/GetApproval',
        {
          form_id: id,
          page: 1,
          pageSize: 100,
        },
        '查询审批记录',
      );
      if (res.data.success) {
        if (res.data.data.initiator === this.$store.state.user.userId) {
          this.isApplication_user = true;
        } else {
          this.isApplication_user = false;
        }
        this.isapprovalMeb = res.data.data.currentapprovals.some(
          (element) => element.approvalid === this.$store.state.user.userId,
        );
        this.approvalStatus = res.data.data.audit_status;
      } else {
      }
    },
    isShowDelBtn() {
      if (this.isShowPackage) {
        return false;
      }
      if (!this.isShowPackage) {
        return true;
      }
      // if (item.file_name && this.isapprovalMeb && this.isShowPackage) {
      //   return true;
      // }
      // if (
      //   item.file_name &&
      //   this.isShowVersion &&
      //   this.isapprovalMeb &&
      //   !this.isShowPackage &&
      //   this.buttonText === '上传发文内容'
      // ) {
      //   return true;
      // }
      // if (
      //   item.file_name &&
      //   !this.isShowPackage &&
      //   this.buttonText !== '上传发文内容'
      // ) {
      //   return true;
      // }
    },
    async downloadFile(file) {
      console.log(file, '文件名字');
      const baseApi = process.env.VUE_APP_BASE_API;

      const fileUrl = `${baseApi}${file.path}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const file_name = file.file_name.replace(/\(.*?\)/g, '');
      saveAs(blob, file_name.trim());
    },
    async downloadZip(files) {
      const baseApi = process.env.VUE_APP_BASE_API;
      const zip = new this.$JSZip();
      const folder = zip.folder('attachments');

      for (let file of files) {
        const fileUrl = `${baseApi}${file.path}`;
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        folder.file(file.file_name, blob);
      }

      zip.generateAsync({ type: 'blob' }).then((content) => {
        this.$saveAs(content, 'attachments.zip');
      });
    },
    // 限制的文件类型
    restrictedTypes(file) {
      const restrictedTypes = [
        'application/msword',
        'application/vnd.ms-excel',
      ];
      if (restrictedTypes.includes(file.type)) {
        this.$message.error('禁止上传 .doc 和 .xls 文件！');
        return false;
      } else {
        return true;
      }
    },
    beforeUpload(file, item) {
      const maxSizeInMB = 100; // 设置文件大小限制为100mb
      if (file.size / 1024 / 1024 > maxSizeInMB) {
        this.$message.error(`文件大小不能超过${maxSizeInMB}MB！`);
        return false;
      }
      // if (this.restrictedTypes(file)) {
      //   this.$emit('upload', { file, item });
      //   return false;
      // }
      this.$emit('upload', { file, item });
    },
    resetUpload(file, item) {
      const maxSizeInMB = 100; // 设置文件大小限制为100MB
      if (file.size / 1024 / 1024 > maxSizeInMB) {
        this.$message.error(`文件大小不能超过${maxSizeInMB}MB！`);
        return false;
      }
      if (this.restrictedTypes(file)) {
        this.$emit('resetUpload', { file, item });
      }
    },
    createBeforeUpload(item) {
      return (file) => this.beforeUpload(file, item);
    },
    openFile(item) {
      const fileExtension = this.getFileExtension(item.path).toLowerCase();
      switch (fileExtension) {
        case 'docx':
          this.filetype = 'docx';
          break;
        case 'doc':
          this.filetype = 'doc';
          break;
        case 'pdf':
          this.filetype = 'pdf';
          break;
        case 'xls':
          this.filetype = 'xls';
          break;
        case 'xlsx':
          this.filetype = 'xlsx';
          break;
        default:
          this.filetype = null;
      }
      if (this.filetype != null && this.filetype != 'pdf') {
        if (this.filetype === 'docx') {
          window.open(item.path.replace(/\.docx?$/, '.pdf'), item.file_name);
        } else if (this.filetype === 'doc') {
          window.open(item.path.replace(/\.doc?$/, '.pdf'), item.file_name);
        } else if (this.filetype == 'xls' || this.filetype == 'xlsx') {
          this.loadExcelFile(item.path, item.file_name);
        } else {
          window.open(
            'https://view.officeapps.live.com/op/view.aspx?src=https://jk.lockhea.com' +
              item.path,
          );
        }
      } else {
        window.open(item.path);
      }
      console.log(item, '打开文件', fileExtension);
    },
    download(url, fileName) {
      let x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function () {
        //self.exportLoading = false;
        let url = window.URL.createObjectURL(x.response);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    getFileExtension(url) {
      return url.split('.').pop();
    },
    deleteFile(item) {
      this.handeladdFileLog(item); //添加文件日志
      this.$emit('delete', item);
    },
    //添加文件日志
    async handeladdFileLog(item) {
      let res = await postData('/admin/File/AddFileLog', item);
      if (res.data.success) {
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async loadExcelFile(filePath, fileName) {
      const baseApi = process.env.VUE_APP_BASE_API;
      const fileUrl = `${baseApi}${filePath}`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      LuckyExcel.transformExcelToLucky(file, (exportJson) => {
        if (!exportJson.sheets || exportJson.sheets.length === 0) {
          return this.$message.warning('当前格式不支持,请下载本地查看');
        }
        // 创建预览内容
        this.initExcel(exportJson, '名称');
      });
    },

    initExcel(exportJson = {}, FileName) {
      window.luckysheet.destroy();
      window.luckysheet.create({
        container: 'luckysheet', // luckysheet为容器id
        lang: 'zh', // 默认语言
        title: FileName,
        //

        allowEdit: false, // 是否允许前台编辑
        sheetFormulaBar: false, // 是否显示公式栏
        enableAddRow: false, // 是否允许添加行
        showsheetbar: true, // 是否显示底部sheet页按钮
        showtoolbar: false, // 是否显示工具栏
        showinfobar: false, // 是否显示顶部信息栏

        data: exportJson.sheets, // excel数据
        userInfo: exportJson.info.name.creator,
      });
      this.luckysheelShow = true;
    },
  },
};
</script>

<style scoped lang="less">
Button {
  margin-right: 12px;
}
.file-box {
  margin-bottom: 12px;
  width: max-content;
  position: relative;
  background-color: #f5f5f5;
  padding: 10px;
  &:last-child {
    margin-bottom: unset;
  }
  div {
    cursor: pointer;
    color: #153b51;
  }
  .file-text {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 10px;
    max-width: 800px;
    margin-right: 20px;
    span {
      white-space: nowrap; /* Prevent text from wrapping to the next line */
      overflow: hidden; /* Hide any overflowing content */
      text-overflow: ellipsis; /* Show ellipsis (...) for overflowing text */
    }
  }
  .action-btn {
    display: flex;
    align-items: center;
    height: 100%;
    font-weight: 400;
    font-size: 14px;
    color: #0061b9;
    line-height: normal;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-right: 12px;
  }
}
</style>
